package com.arena_web.ui.sections.profile.edit

/**
 * Common world languages for the profile language picker. Free-form strings —
 * users can pick from this list via autocomplete and the value goes to the
 * `users.languages` JSONB column as-is.
 */
object Languages {
    val ALL: List<String> = listOf(
        "Afrikaans", "Albanian", "Amharic", "Arabic", "Armenian",
        "Azerbaijani", "Basque", "Belarusian", "Bengali", "Bosnian",
        "Bulgarian", "Burmese", "Catalan", "Cebuano", "Chinese",
        "Croatian", "Czech", "Danish", "Dutch", "English",
        "Esperanto", "Estonian", "Finnish", "French", "Galician",
        "Georgian", "German", "Greek", "Gujarati", "Haitian Creole",
        "Hausa", "Hebrew", "Hindi", "Hungarian", "Icelandic",
        "Igbo", "Indonesian", "Irish", "Italian", "Japanese",
        "Javanese", "Kannada", "Kazakh", "Khmer", "Kinyarwanda",
        "Korean", "Kurdish", "Kyrgyz", "Lao", "Latin",
        "Latvian", "Lithuanian", "Luxembourgish", "Macedonian", "Malagasy",
        "Malay", "Malayalam", "Maltese", "Maori", "Marathi",
        "Mongolian", "Nepali", "Norwegian", "Pashto", "Persian",
        "Polish", "Portuguese", "Punjabi", "Romanian", "Russian",
        "Samoan", "Scots Gaelic", "Serbian", "Sesotho", "Shona",
        "Sindhi", "Sinhala", "Slovak", "Slovenian", "Somali",
        "Spanish", "Sundanese", "Swahili", "Swedish", "Tajik",
        "Tamil", "Tatar", "Telugu", "Thai", "Turkish",
        "Turkmen", "Ukrainian", "Urdu", "Uyghur", "Uzbek",
        "Vietnamese", "Welsh", "Xhosa", "Yiddish", "Yoruba",
        "Zulu",
    )

    /**
     * Autocomplete search: returns languages whose name starts with [query]
     * (case-insensitive) first, then those that contain [query] anywhere.
     * Empty query → empty list (UI hides suggestions on blank input).
     */
    fun search(query: String, exclude: Set<String> = emptySet(), limit: Int = 8): List<String> {
        val q = query.trim().lowercase()
        if (q.isEmpty()) return emptyList()
        val excludeLower = exclude.map { it.lowercase() }.toSet()
        val (starts, contains) = ALL
            .asSequence()
            .filter { it.lowercase() !in excludeLower }
            .partition { it.lowercase().startsWith(q) }
        return (starts + contains.filter { q in it.lowercase() }).take(limit)
    }
}
